<template>
  <button
    title="Limpar campo"
    @click.prevent="$emit('click', $emit)"
    tabindex="-1"
    class="cursor-pointer outline-none focus:outline-none transition-all text-gray-300 hover:text-red-600"
  >
    <svg
      class="w-4 h-4 mx-2 fill-current"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
</template>
